import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=A%20dramatic%20interview%20scene%20concept%20with%20silhouette%20and%20warm%20spotlight%2C%20dark%20moody%20editorial%20photography%20style%2C%20crimson%20and%20charcoal%20tones%2C%20cinematic%20atmosphere%2C%20no%20faces%20visible%2C%20no%20readable%20text&width=600&height=340&seq=media-1-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20chaotic%20film%20set%20with%20dramatic%20tension%2C%20silhouettes%20of%20people%20in%20conflict%2C%20warm%20crimson%20and%20dark%20tones%2C%20editorial%20photography%20style%2C%20no%20clear%20faces%2C%20cinematic%20lighting&width=600&height=340&seq=media-2-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20abstract%20data%20analytics%20and%20investigation%20concept%20with%20magnified%20documents%2C%20dark%20moody%20atmosphere%2C%20warm%20crimson%20accents%2C%20editorial%20design%20quality%2C%20no%20readable%20text&width=600&height=340&seq=media-3-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20mysterious%20anonymous%20source%20concept%20with%20shadow%20figure%20and%20documents%2C%20dramatic%20lighting%2C%20warm%20crimson%20and%20dark%20palette%2C%20investigative%20journalism%20aesthetic%2C%20no%20clear%20faces&width=600&height=340&seq=media-4-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20visual%20timeline%20of%20rise%20and%20fall%20concept%20with%20abstract%20chart%20and%20dramatic%20shadows%2C%20warm%20crimson%20highlights%2C%20editorial%20illustration%20style%2C%20no%20readable%20text&width=600&height=340&seq=media-5-2026&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line"></i>
            视频爆料
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">媒体聚焦</h2>
          <p className="text-foreground-600 text-sm">独家视频报道，直击事件第一现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-secondary-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.backgroundColor = 'oklch(0.87 0.011 90)';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl text-primary-600 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs bg-black/70 text-background-50 px-2 py-0.5 rounded">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 text-xs px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-2">{item.views} 次播放</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}